import { IntentType } from '@40seas/entities/intents';
import { WiserfundingCompanySearch } from '@40seas/entities/wiserfunding';
import { Resources } from '@40seas/frontend/dashboard/providers';
import { Currency } from '@40seas/models';
import { Identifier } from 'react-admin';

export const resourcePropertyProvider = {
    common: {
        log: (id: Identifier) => `${id}/log`,
    },
    users: {
        credentials: 'credentials',
        application: 'application',
    },
    creditline: {
        activate: (id: Identifier) => `${id}/activate`,
    },
    experian: {
        report: (id: Identifier) => `${id}/report`,
    },
    'allianz/companies': {
        refreshCover: (id: Identifier) => `${id}/refresh-cover`,
        find: (companyId: string) => `find/${companyId}`,
    },
    'atradius/companies': {
        find: (companyId: string) => `find/${companyId}`,
    },
    'allianz/covers': {
        refresh: (id: Identifier) => `${id}/refresh`,
    },
    'atradius/covers': {
        refresh: (id: Identifier) => `${id}/refresh`,
    },
    'allianz/cover-requests': {
        refresh: (id: Identifier) => `${id}/refresh`,
    },
    files: {
        download: (fileId: string) => `downloadUrl/${fileId}`,
        upload: 'uploadUrl',
    },
    attachments: {
        download: (attachmentId: string) => `downloadUrl/${attachmentId}`,
    },
    bankTransactions: {
        getBankTransactionsStatus: () => `bank-transactions-status`,
    },
    'bank-account': {
        getReceivingBankAccount: (currency: Currency) => `receiving-bank-accounts/${currency}`,
    },
    'buyers/ownership': {
        getBuyerUsers: (id) => `${id}/users`,
    },
    intents: {
        create: (intentType: IntentType) => `${intentType}`,
        init: (intentType: IntentType) => `${intentType}/init`,
        buyerMissingInfo: (buyerId: string) => `missing-information/buyers/${buyerId}`,
        supplierMissingInfo: `missing-information/supplier`,
    },
    'heron/reports': {
        refresh: (id: Identifier) => `${id}/refresh`,
        refreshStatus: (id: Identifier) => `${id}/refresh-status`,
        process: (id: Identifier) => `${id}/process`,
    },
    buyers: {
        setDefaultPaymentMethod: (id: string) => `${id}/set-default-payment-method`,
        setAutomaticPaymentMethod: (id: string) => `${id}/set-automatic-payment-method`,
        unsetAutomaticPaymentMethod: (id: string) => `${id}/unset-automatic-payment-method`,
        move: (id: string) => `${id}/move`,
        skipFinancialConnection: (id: string) => `${id}/skip-financial-connection`,
    },
    funds: {
        move: (id: string, buyerId: string) => `${id}/move/${buyerId}`,
    },
    configs: {
        getStripePublicKey: () => 'stripe/public',
    },

    underwriting: {
        execute: (id: string | number) => `${id}/execute`,
    },
    invoices: {
        ocrResults: (id: string) => `${id}/ocr`,
        fileOcr: (fileId: string) => `ocr/${fileId}/file`,
    },
    sync: {
        replicate: 'replicate',
    },
    leads: {
        createOrganization: (id: string) => `${id}/create-organization`,
    },
    audits: {
        users: () => `audits/users`,
    },
    emails: {
        html: (id: string) => `html/${id}`,
    },
    'aiprize/companies': {
        refresh: (id: Identifier) => `${id}/refresh`,
        runVerification: (id: Identifier) => `${id}/verification`,
    },
    'wiserfunding/companies': {
        searchCompany: (id: Identifier) => `${id}/find-and-update`,
        manualCompanySearch: (wiserfundingCompanySearch: WiserfundingCompanySearch) => `manual-company-search`,
        createReport: (id: Identifier) => `${id}/report`,
    },
    'notifications/user-customizations': {
        getMe: 'me',
    },
    checkout: {
        sendReminder: (id: Identifier) => `${id}/send-reminder`,
        createReminder: (id: Identifier) => `${id}/reminder`,
    },
    plaid: {
        refresh: (id: Identifier) => `${id}/refresh`,
    },
    'credit-safe/companies': {
        refresh: (id: Identifier) => `${id}/refresh`,
    },
    'credit-safe/reports': {
        refresh: (id: Identifier) => `${id}/refresh`,
    },
    'credit-reviews': {
        refresh: (id: Identifier) => `${id}/refresh`,
    },
} satisfies Partial<{ [key in Resources]: any } & { common: any }>;
